// @flow
import {
  TOGGLE_SEARCH_EMPLOYEE_POPUP,
  SET_SELECTED_EMPLOYEE_LIST,
  SET_PREVIEW_EMPLOYEE,
  API_ERROR,
  SET_PREVIEW_EMPLOYEE_SUCCESS,
  SET_EMPLOYEE_DETAIL_SUCCESS,
  SET_EMPLOYEE_DETAIL,
  SET_EMPLOYEE_EXTERNAL_PROFILE_SUCCESS,
  SET_EMPLOYEE_EXTERNAL_PROFILE,
  SET_EMPLOYEE_ALARM_SETTING_SUCCESS,
} from "./actionTypes";

const INIT_STATE = {
  // isSearchEmployeePopupOpen: false,
  searchEmployeeCallback: null,
  searchEmployeeOptions: {},
  selectedEmployeeList: [],
  previewEmployee: null,
  employeeDetail: null,
  error: "", // 해당 스토어에서 사용되는 api 에러가 있을 경우 error 표기
  previewEmployeeProfile: null,
};

const Employee = (state = INIT_STATE, action) => {
  switch (action.type) {
    case TOGGLE_SEARCH_EMPLOYEE_POPUP:
      const { callback, ...options } = action.payload || {};
      return {
        ...state,
        searchEmployeeCallback: callback,
        searchEmployeeOptions: options || {},
      };
    case SET_SELECTED_EMPLOYEE_LIST:
      return {
        ...state,
        selectedEmployeeList: action.payload,
      };
    case SET_PREVIEW_EMPLOYEE:
      return {
        ...state,
      };
    case SET_PREVIEW_EMPLOYEE_SUCCESS:
      return {
        ...state,
        previewEmployee: action.payload,
      };
    case SET_EMPLOYEE_DETAIL:
      return {
        ...state,
      };
    case SET_EMPLOYEE_DETAIL_SUCCESS:
      return {
        ...state,
        employeeDetail: action.payload,
      };
    case SET_EMPLOYEE_EXTERNAL_PROFILE:
      return {
        ...state,
      };
    case SET_EMPLOYEE_EXTERNAL_PROFILE_SUCCESS:
      return {
        ...state,
        previewEmployeeProfile: action.payload,
      };
    case SET_EMPLOYEE_ALARM_SETTING_SUCCESS:
      return {
        ...state,
        previewAlarmSettings: action.payload,
      };
    case API_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default Employee;
